<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #142a49 !important; font-size: 14px"
    >
      <h6 class="title">
        Reports &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <!-- Filter -->
  <div class="row m-1">
    <!-- report type -->
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterReportType">Report Type</label>
        <select
          id="filterReportType"
          class="form-control"
          placeholder="Select"
          [(ngModel)]="filterReportType"
          (change)="onReportTypeChange($event)"
        >
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of reportTypes" [value]="item.id">
            {{ item.reportType }}
          </option>
        </select>
      </div>
    </div>
    <!-- month / month range -->
    <div class="col-12 col-md-3" *ngIf="filterReportType">
      <div class="form-group">
        <div>
          <input
            type="radio"
            id="filterMonth"
            name="filterIsMonthRange"
            [value]="false"
            [(ngModel)]="filterIsMonthRange"
            (change)="onRangeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="filterMonth">
            Month
          </label>
          &nbsp;
          <input
            type="radio"
            id="filterRange"
            name="filterIsMonthRange"
            [value]="true"
            [(ngModel)]="filterIsMonthRange"
            (change)="onRangeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="filterRange">
            Range
          </label>
        </div>
        <input
          *ngIf="filterIsMonthRange; else elseMonthRange"
          type="text"
          [(ngModel)]="filterDateSelection"
          class="form-control"
          placeholder="Select Month"
          bsDaterangepicker
          [bsConfig]="{ rangeInputFormat: 'MMM YYYY', minMode: 'month' ,showWeekNumbers: false}"
          [maxDate]="maxDateForPicker"
        />

        <ng-template #elseMonthRange>
          <input
            type="text"
            [(ngModel)]="filterDateSelection"
            class="form-control"
            placeholder="Select Month"
            bsDatepicker
            [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month',showWeekNumbers: false }"
            [maxDate]="maxDateForPicker"
          />
        </ng-template>
      </div>
    </div>
    <!-- Allies -->
    <div
      class="col-12 col-md-3"
      *ngIf="
        role === 'ADMINISTRATOR' &&
        filterDateSelection &&
        (filterReportType === '1' || filterReportType === '3')
      "
    >
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          {{ filterReportType === "1" ? "Select Advisor" : "Select Partner" }}
        </label>
        <ng-multiselect-dropdown
          [placeholder]="'Select'"
          [settings]="dropdownSettings"
          [data]="advisors"
          [(ngModel)]="filterAdvisors"
          (onSelect)="onItemSelect($event)"
          (onSelectAll)="onSelectAll($event)"
        >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterReportType"></label>
        <div class="d-flex gap-2 mb-3">
          <button
            *ngIf="isShowGenerateReport()"
            class="btn btn-primary"
            style="font-size: 12px"
            (click)="clickGenerateReport()"
            title="Generate Report"
          >
            Generate Report
          </button>
          <button
            *ngIf="data.length > 0"
            class="btn btn-primary"
            style="font-size: 12px"
            (click)="downloadReports()"
            title="Download Reports"
          >
            Download Reports
          </button>
          <button
            class="btn btn-primary"
            style="font-size: 12px"
            (click)="applyFilters()"
            title="Apply Filters"
          >
            Apply filter
          </button>
          <button
            class="btn btn-secondary"
            style="font-size: 12px"
            (click)="resetFilters()"
            title="Reset Filters"
          >
            Reset filter
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Datatable -->
  <div class="row m-1 mt-4" *ngIf="isViewReport && filterReportType != '11'">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th style="width: 30px">#</th>
            <th
              *ngFor="let header of tableHeaders | parseHeaders"
              [ngStyle]="{
                'width.px':
                  header === 'Status' ||
                  header === 'Payment Status' ||
                  header === 'Progress Status'
                    ? 100
                    : 'auto'
              }"
            >
              {{ header | titlecase }}
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index">
            <td>{{ i + 1 }}</td>
            <ng-container *ngFor="let field of tableHeaders | parseValues">
              <td [ngSwitch]="field">
                <!-- Case for 'date' field -->
                <ng-container *ngSwitchCase="'date'">
                  {{ item[field] | date : "MMMM yyyy" }}
                </ng-container>

                <ng-container *ngSwitchCase="'progressStatus'">
                  <!-- <div class="text-center" *ngIf="item[field] === 'Completed'">
                    <img
                      src="assets/img/report/completed.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div
                    class="text-center"
                    *ngIf="item[field] === 'In Progress'"
                  >
                    <img
                      src="assets/img/report/in-progress.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div
                    class="text-center"
                    *ngIf="
                      item[field] === 'Requested' || item[field] === 'Queued'
                    "
                  >
                    <img
                      src="assets/img/report/queued.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div>
                  <div class="text-center" *ngIf="item[field] === 'Cancelled'">
                    <img
                      src="assets/img/report/cancelled.png"
                      alt=""
                      width="20px"
                      height="20px"
                    />
                  </div> -->
                  <div class="progress">
                    <div
                      *ngIf="item[field] === 'Completed'"
                      class="progress-bar bg-success"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                    <div
                      *ngIf="
                        item[field] === 'In Progress' ||
                        item[field] === 'Requested' ||
                        item[field] === 'Queued'
                      "
                      class="progress-bar progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                    <div
                      *ngIf="item[field] === 'Cancelled'"
                      class="progress-bar bg-warning"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {{ item[field] }}
                    </div>
                  </div>
                </ng-container>

                <!-- Case for 'status' field -->
                <ng-container *ngSwitchCase="'paymentStatus'">
                  <!-- <button class="paymentStatus" (click)="showPayment(item)">
                    {{ item[field] }}
                  </button> -->
                  {{ item[field] }}
                </ng-container>

                <!-- Default case for other fields -->
                <ng-container *ngSwitchDefault>
                  {{ item[field] }}
                </ng-container>
              </td>
            </ng-container>
            <!-- <ng-container *ngFor="let field of tableHeaders | parseValues">
              <td *ngIf="field === 'date'; else notDate">
                {{ item[field] | date : "MMMM yyyy" }}
              </td>
              <ng-template #notDate>
                <td>{{ item[field] }}</td>
              </ng-template>
            </ng-container> -->
            <td>
              <div
                style="min-width: 20px"
                data-bs-target="showmemberlist"
                class="d-flex gap-3"
              >
                <a
                  class="viewicon"
                  title="View Detail"
                  data-toggle="tooltip"
                  style="cursor: pointer;"
                  *ngIf="actions?.includes('view')"
                >
                  <i
                    class="bi bi-eye-fill"
                    style="color: rgb(56, 66, 159); cursor: pointer"
                    (click)="viewDetail(item)"
                  ></i>
                </a>
                <a
                  class="viewicon"
                  title="Download Excel"
                  data-toggle="tooltip"
                  style="cursor: pointer;"
                  *ngIf="actions?.includes('xlsx')"
                >
                  <i
                    class="bi bi-file-earmark-excel-fill"
                    style="color: rgb(56, 159, 108); cursor: pointer"
                    (click)="downloadExcelReport(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="View PDF"
                  data-toggle="tooltip"
                  style="cursor: pointer;"
                  *ngIf="actions?.includes('pdf')"
                >
                  <i
                    class="bi bi-file-earmark-pdf-fill"
                    style="color: rgb(159, 56, 56); cursor: pointer"
                    (click)="viewPdf(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Adjustment"
                  data-toggle="tooltip"
                  style="cursor: pointer;"
                  *ngIf="item.paymentStatus === 'Not Paid'"
                >
                  <i
                    class="bi bi-sliders"
                    style="color: rgb(56, 75, 159); cursor: pointer"
                    (click)="viewAdjustment(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Finalize report and Publish"
                  data-toggle="tooltip"
                  style="cursor: pointer;"
                  *ngIf="item.reportStatus === 'Draft'"
                >
                  <i
                    class="bi bi-check-circle"
                    style="color: rgb(56, 159, 99); cursor: pointer"
                    (click)="viewFinalize(item)"
                  ></i>
                </a>

                <a
                  class="viewicon"
                  title="Send Invite"
                  data-toggle="tooltip"
                  *ngIf="actions?.includes('email')"
                >
                  <i
                    class="fa fa-send-o cursor: pointer;"
                    style="color: rgb(56, 76, 159); cursor: pointer"
                    (click)="invitationMail(item)"
                  >
                  </i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row m-1 mt-4" *ngIf="isViewReport && filterReportType == '11'">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th>Item</th>
            <th>Customer ID</th>
            <th>Invoice No</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Type</th>
            <th>Primary advisor</th>
            <th>Reason if avail</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of arrearsData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{item.customerId}}</td>
            <td>{{item.invoiceNumber}}</td>
            <td>{{item.invoiceAmount}}</td>
            <td>{{item.status}}</td>
            <td>{{item.customerObj.isCorporateAccount ? "CORP" : "GIG"}}</td>
            <td>{{item.customerObj.broker.name}}</td>
            <td>NA</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>

<div
  class="modal viewModal"
  id="advisor-report-modal"
  role="dialog"
  aria-labelledby="modal-label"
  style="display: none"
>
  <div
    class="modal-dialog modal-lg modal-dialog-centered"
    role="document"
    style
    id="heightWidthModal2"
  >
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{ title }}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 20px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
          ></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <pdf-viewer
          *ngIf="true"
          [src]="pdfSrc"
          id="pdf-viewer"
          style="width: 100%"
          class="providersSize"
        ></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-light"
          data-bs-dismiss="modal"
          id="closeButton"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- PAD REPORT MODAL -->
<div
  class="modal"
  id="pad-report-modal"
  data-bs-backdrop="static"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    role="document"
    id="heightModalPad"
  >
    <div class="modal-content">
      <div class="modal-header text-light" style="height: 35px">
        <p class="modal-title" id="staticBackdropLabel">PAD Report Detail</p>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 20px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
            (click)="closePopup()"
          ></i>
        </div>
      </div>
      <div
        class="model-body"
        style="
          margin-top: 20px;
          padding-right: 15px;
          padding-left: 15px;
          overflow-y: scroll;
        "
      >
        <div class="row">
          <div class="table-responsive">
            <table
              id="DataTables_Table_2"
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger2"
              class="table text-nowrap"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Company</th>
                  <th>Customer name</th>
                  <th>Customer ID</th>
                  <th>Billed Amount</th>
                  <th>Charged Amount</th>
                  <th>Due date</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paymentDetails; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item["Company"] }}</td>
                  <td>{{ item["Customer name"] }}</td>
                  <td>{{ item["Customer ID"] }}</td>
                  <td>{{ item["Billed amount"] }}</td>
                  <td>{{ item["Charged amount"] }}</td>
                  <td>{{ item["Due date"] }}</td>
                  <td>{{ item["Balance"] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closePopup()"
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model For Payment -->
<div
  class="modal fade"
  data-bs-backdrop="static"
  id="payment-modal"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Payment</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 4px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
          ></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="input-wrapper row">
          <div class="form-group col-12">
            <label> Month </label>
            <input
              type="text"
              [(ngModel)]="paymentMonth"
              class="form-control"
              readonly
            />
          </div>
          <div class="form-group col-12">
            <label> Date of Payment </label>
            <input
              type="text"
              [(ngModel)]="paymentDate"
              class="form-control"
              placeholder="Select Month"
              bsDatepicker
              [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
              [maxDate]="maxDateForPicker"
            />
          </div>
          <div class="form-group col-12">
            <label> Amount Paid </label>
            <input
              type="text"
              [(ngModel)]="paymentAmountPaid"
              class="form-control"
              placeholder="Enter amount"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
          (click)="resetPayment()"
        >
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="submitPayment()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ADJUSTMENT -->
<div
  class="modal fade"
  data-bs-backdrop="static"
  id="adjustment-modal"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Adjustment - {{ titleAdjustment }}</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 4px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
          ></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="input-wrapper row">
          <form [formGroup]="formAdjustment" (ngSubmit)="onSubmitAdjustment()">
            <div class="row form-group col-12">
              <div class="col-6">
                Month<br />
                {{
                  this.formAdjustment.get("month").value | date : "MMMM yyyy"
                }}
              </div>
              <div class="col-6">
                <div>
                  <input
                    type="radio"
                    id="credit"
                    name="type"
                    [value]="'credit'"
                    formControlName="type"
                  />
                  <label class="form-check-label ps-1 my-auto" for="credit">
                    Credit
                  </label>
                  &nbsp;
                  <input
                    type="radio"
                    id="debit"
                    name="type"
                    [value]="'debit'"
                    formControlName="type"
                  />
                  <label class="form-check-label ps-1 my-auto" for="debit">
                    Debit
                  </label>
                </div>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter amount"
                  formControlName="amount"
                  currencyMask
                />
              </div>
            </div>
            <div class="form-group col-12">
              <label> Reason </label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Enter description"
                formControlName="description"
                rows="4"
              ></textarea>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between py-2">
        <div>
          <button
            *ngIf="isEditAdjustment"
            type="button"
            class="btn btn-primary"
            (click)="onHistoryAdjustment()"
          >
            History
          </button>
          <button
            *ngIf="isEditAdjustment"
            type="button"
            class="btn btn-primary me-2"
            (click)="onVoidAdjustment()"
          >
            Void
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-secondary me-2"
            data-bs-dismiss="modal"
            #closemodel
            (click)="onResetAdjustment()"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="onSubmitAdjustment()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  data-bs-backdrop="static"
  id="adjustment-history-modal"
  tabindex="-2"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">History - {{ titleAdjustment }}</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i
            style="margin-right: 4px"
            class="bi bi-x-circle"
            role="button"
            aria-hidden="true"
            data-bs-dismiss="modal"
          ></i>
        </div>
      </div>
      <div class="modal-body" style="min-height: 230px">
        <div class="table-responsive">
          <table class="table text-nowrap">
            <thead>
              <tr>
                <th style="width: 30px">#</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Modified By</th>
                <th>Modified Date</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of historyAdjustment; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.type }}</td>
                <td class="text-end">$ {{ item.amount | number }}</td>
                <td>{{ item.modifiedUsername }}</td>
                <td>
                  {{ item.modifiedDatetime | date : "MMM dd, yyyy HH:mm" }}
                </td>
                <td>{{ item.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button
          type="button"
          class="btn btn-secondary me-2"
          data-bs-dismiss="modal"
          #closemodel
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
